import { RouterManager } from '@aclass/admin/managers';
import { AdditionalProductStory } from '@aclass/admin/storage/actions';
import { IAdditionalProductModuleState, IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class AdditionalProductEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:additional-product-edit';

    private id: IAdditionalProductModuleState['editPageRecordId'];

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IAdditionalProductModuleState['editPageRecordId']>(['additionalProductModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(AdditionalProductEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        const id = parseInt(route.params.id);
        this.id = id;
        this.ngRdx.dispatch(AdditionalProductStory.dryRunEditPage(id));
    }
}
